<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" ref="table">
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :rows="params"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getLocationBill,
  getDetails,
  update,
  delItem,
  confirmBill,
  sync,
  writeOffBill, exportLB, exportLbApi,
} from "@/api/finance/location_bill_hq";
import { getAllClient, getCompanies } from "@/api/user/client";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import { getAllService } from "@/api/user/internal";
import Details from "./details";
import invoice from "@/components/invoice";

export default {
  name: "location_bill_hq",
  components: {
    cTable,
    Details,
    invoice
  },
  data() {
    return {
      methods: {
        list: getLocationBill,
        getDetails,
        getAllClient,
        getCompanies,
        getAllService,
        update,
        sync,
        delItem,
        confirmBill,
        writeOffBill,
        // beforeHandleList: ({ data }) => {
        //   this.totalAmount = [];
        //   this.totalAmount.push({
        //     text: this.$t("total"),
        //     replace_currency: "CNY",
        //     total_amount: data.totalAmount
        //   });
        // }
      },
      totalAmount: [],
      modals: {
        update: {
          methods: {
            ok({ row, close }) {
              const data = this.handleFilterData();
              data.id = row.id;
              this.$page.handleRequestMethods("update", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bill_name: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
              num: [
                {
                  required: true,
                  type: "number",
                },
              ],
              volume: [
                {
                  required: true,
                  type: "number",
                },
              ],
              num_price: [
                {
                  required: true,
                  type: "number",
                },
              ],
              volume_price: [
                {
                  required: true,
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { num: 24 },
            { num_price: 24 },
            { volume: 24 },
            { volume_price: 24 },
            { bill_name: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("quantity_num"),
              key: "num",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("quantity_num"),
              bind: {
                style: {
                  width: "100%",
                },
                step: 1,
                min: 0,
              },
              default: 0,
            },
            {
              name: () => this.$t("quantity_num") + this.$t("doublePrice"),
              key: "num_price",
              component: "InputNumber",
              placeholder: () =>
                this.$t("enter") +
                this.$t("quantity_num") +
                this.$t("doublePrice"),
              bind: {
                style: {
                  width: "100%",
                },
                step: 0.01,
                min: 0,
              },
              default: 0,
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("square"),
              bind: {
                style: {
                  width: "100%",
                },
                step: 0.01,
                min: 0,
              },
              default: 0,
            },
            {
              name: () => this.$t("square") + this.$t("doublePrice"),
              key: "volume_price",
              component: "InputNumber",
              placeholder: () =>
                this.$t("enter") + this.$t("square") + this.$t("doublePrice"),
              bind: {
                style: {
                  width: "100%",
                },
                step: 0.01,
                min: 0,
              },
              default: 0,
            },
            {
              name: () => this.$t("codNAme"),
              key: "bill_name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
          ],
        },
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row))
              if (!data.invoice.is_open) delete data['invoice']
              this.$page
                .handleRequestMethods("writeOffBill", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              // status: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // client_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // bank: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              check_amount: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              // check_amount_currency: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // transfer_method: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // transaction_id: [
              //   {
              //     required: true,
              //     message: "cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              o_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            // { status: 24 },
            // { client_id: 24 },
            // { o_type: 24 },
            // { bank_id: 24 },
            // { bank: 24 },
            { check_amount: 24 },
            { status: 24 },
            { o_type: 24 },
            { remarks: 24 },
            // { check_amount_currency: 24 },
            // { transaction_id: 24 },
            // { remarks: 24 }
            { invoice: 24 }
          ],
          fields: [
            {
              name: () => this.$tz("是否,开票"),
              key: 'invoice',
              render(h, p) {
                if (!p.row.invoice) p.row.invoice = { is_open: 0, amount: '' }
                return h(invoice, {
                  props: {
                    formData: p.row.invoice
                  },
                })
              }
            },
            {
              name: this.$t("check_amount"),
              key: "check_amount",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("check_amount"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("refuse"), value: 0 },
                { label: this.$t("allow"), value: 1 },
              ],
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("type"),
              key: "o_type",
              component: "Radio",
              options: [
                { label: this.$t("onLine"), value: 1 },
                { label: this.$t("offLine"), value: 2 },
              ],
              bind: {
                border: true,
              },
              default: 1,
              show({ row }) {
                return row.status == 1;
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5,
              },
              show({ row }) {
                return row.o_type == 2;
              },
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 60,
            },
          },
          footer: { show: () => false },
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        searchs: [
          {
            key: "month",
            placeholder() {
              return this.$t("select") + this.$t("month");
            },
            component: "DatePicker",
            bind: {
              // options: {
              //   disabledDate(time) {
              //     return time.getTime() > Date.now() - 86400000 * 31;
              //   }
              // },
              style: {
                width: "120px",
              },
              type: "month",
            },
            methods: {
              format({ value }) {
                return value ? this.format.monthFormat(value, "YYYY-MM") : "";
              },
            },
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: [
              {
                label: this.$t("wait") + this.$t("confirm"),
                value: 1,
              },
              {
                label: this.$t("wait") + this.$t("writeOff"),
                value: 4,
              },
              {
                label: this.$t("WrittenOff"),
                value: 9,
              },
            ],
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "salesman_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            // config: {
            //   label: "account",
            //   value: "id"
            // }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 567,
            },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
            },
            // {
            //   name: () => this.$t("writeOff"),
            //   type: "writeOff",
            //   fnName: "writeOff",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // }
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary",
              },
            },
          ],
          methods: {
            sync() {
              this.handleRequestMethods("sync").then((res) => {
                this.getList();
              });
            },
            export() {
              this.exportExc();
            },
            allBill() {
              let data = {
                bill_id: this.selectAll.map((item) => item.id),
              };
              this.handleRequestMethods(
                "exportAllBill",
                data,
                false,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload, "_blank");
                // this.closeLoading();
              });
            },
            // monthBill() {
            //   let data = {
            //     id: this.selectAll.map(item => item.id)
            //   };
            //   this.openLoading();
            //   this.handleRequestMethods("exportMonthBill", data).then(res => {
            //     window.open(this.$globalUrl + res.payload);
            //     this.closeLoading();
            //   });
            // },
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$t("add"));
              });
            },
            // writeOff() {
            //   this.getModal("writeOff").setTitle(this.$t("writeOff"));
            //   this.getModal("writeOff").type = "batchWriteOff";
            //   this.getModal("writeOff").open();
            // }
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("month"),
          key: "bill_date",
          minWidth: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          component: this.$hasPermission(974) || true ? "Button" : "span",
          minWidth: 200,
          copy: true,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              // if (!this.$hasPermission(974)) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            },
          },
        },
        {
          name: this.$t("clientName"),
          key: "client_account",
          minWidth: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        //    {
        //      name: this.$t("salesman"),
        //      key: "saleman",
        //      minWidth: 100,
        // methods:{
        // 	render({field,row}){
        // 		return row.financeInfo[field.key]
        // 	}
        // }
        //    },
        {
          name: () => this.$t("codNAme"),
          align: "center",
          key: "bill_name",
          minWidth: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          minWidth: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        // {
        //   name: () => this.$t("orderNums"),
        //   key: "order_nums",
        //   align: "center",
        //   minWidth: 80
        // },
        // {
        //   name: () => this.$t("total_votes"),
        //   align: "center",
        //   key: "total_votes",
        //   width: 80
        // },
        // {
        //   name: () => this.$t("amount") + "(CNY)",
        //   key: "total_cny",
        //   align: "center",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("amount") + "(USD)",
        //   align: "center",
        //   key: "total_usd",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("rate") + "(USD-CNY)",
        //   align: "center",
        //   key: "usd_to_cny_rate",
        //   width: 130
        // },
        {
          name: () => this.$t("total_amount"),
          key: "amount",
          width: 110,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("currencyCode"),
          key: "currency",
          width: 80,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        // {
        //   name: () => this.$t("clientName"),
        //   align: "center",
        //   key: "clientInfo",
        //   width: 100,
        //   methods: {
        //     render({ value }) {
        //       return value && value.account;
        //     }
        //   }
        // },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          width: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("createUser"),
          key: "create_account",
          width: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("location_t"),
          children: [
            {
              name: () => this.$t("quantity_num"),
              key: "num",
              width: 110,
              methods: {
                render({ field, row }) {
                  return row.financeInfo[field.key];
                },
              },
            },
            {
              name: () => this.$t("quantity_num") + this.$t("doublePrice"),
              key: "num_price",
              width: 110,
              methods: {
                render({ field, row }) {
                  return row.financeInfo[field.key];
                },
              },
            },
            {
              name: () => this.$tz("SKU,个数"),
              key: "financeInfo.sku",
              minWidth: 110,
            },
            {
              name: () => this.$tz("SKU,单价"),
              key: "financeInfo.sku_price",
              minWidth: 110,
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              width: 110,
              methods: {
                render({ field, row }) {
                  return row.financeInfo[field.key];
                },
              },
            },
            {
              name: () => this.$t("square") + this.$t("doublePrice"),
              key: "volume_price",
              width: 110,
              methods: {
                render({ field, row }) {
                  return row.financeInfo[field.key];
                },
              },
            },
          ],
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          minWidth: 170,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        {
          name: () => this.$t("audit_time"),
          key: "check_time",
          minWidth: 170,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        // {
        //   name: () => this.$t("check_time"),
        //   key: "check_time",
        //   align: "center",
        //   minWidth: 170
        // },

        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100,
          methods: {
            render({ field, row }) {
              return row.financeInfo[field.key];
            },
          },
        },
        // {
        //   name: () => this.$t("b2bClient") + this.$t("order_desc"),
        //   key: "client_remarks",
        //   align: "center",
        //   minWidth: 170
        // },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 390,
          fixed: "right",
          list: [
            // {
            //   name: () => this.$t("addTo"),
            //   type: "append",
            //   fnName: "append",
            //   bind: {
            //     type: "warning"
            //   },
            //   disabled({ row }) {
            //     return row.financeInfo.status != "WAIT_CONFIRM";
            //   }
            //   // id: 365
            // },
            // {
            //   name: () => this.$t("resAmount"),
            //   type: "resetAmount",
            //   fnName: "resetAmount",
            //   bind: {
            //     type: "error"
            //   },
            //   disabled({ row }) {
            //     return row.financeInfo.status != "WAIT_CONFIRM";
            //   },
            //   id: 569
            // },
            {
              name: () => this.$t("导出"),
              type: "exportLB",
              fnName: "exportLB",
              bind: {
                type: "default",
              },
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.financeInfo.status != 1;
              },
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.financeInfo.status != 1;
              },
            },
            // {
            //   name: () => this.$t("hedging"),
            //   type: "hedge",
            //   fnName: "hedge",
            //   bind: {
            //     type: "error"
            //   },
            //   disabled({ row }) {
            //     return row.financeInfo.status != "CONFIRMED";
            //   }
            // },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.financeInfo.status != 4;
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.financeInfo.status != 1;
              },
            },
          ],
          methods: {
            hedge({ row }) {
              let data = {
                type: "HW",
                bill_id: row.id,
              };
              this.handleRequestMethods("waitOffBill", data).then((res) => {
                let data = res.payload.data;
                row.token = res.payload.token;
                row.hedge_bill_amount = 0;
                row.client_name = row.clientInfo && row.clientInfo.account;
                row.final_amount_cny = row.amount;
                this.getModal("hedge").open(row, function () {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("hedging") + ")"
                  );
                  this.list = data;
                });
              });
            },
            exportLB({ row }) {
              exportLbApi(row.financeInfo.id).then(res => {
                window.open('https://oms.vnlin.com/' + res.data.payload.src.substring(4))
              })
            },
            resetAmount({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.openLoading();
                  this.handleRequestMethods("resetHwAmount", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },

            append({ row }) {
              this.getModal("append").open({ id: row.id }, function () {
                this.setTitle(this.$t("addTo"));
              });
            },
            async update({ row }) {
              this.getModal("update").open(
                { ...row.financeInfo, id: row.id },
                function () {
                  this.setTitle(
                    this.$t("bill1") +
                    "(" +
                    row.bill_number +
                    ")" +
                    this.$t("update")
                  );
                }
              );
            },
            confirmOrder({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("confirmBill", { id: row.id }).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            writeOff({ row }) {
              let data = {
                id: row.id,
                check_amount: row.financeInfo.amount,
              };
              this.getModal("writeOff").open(data, function () {
                this.setTitle(
                  this.$t("bill1") +
                  "(" +
                  row.bill_number +
                  ")" +
                  this.$t("writeOff")
                );
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("delItem", { id: row.id }).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
  // activated() {
  //   this.$refs["table"].$refs[
  //     "header"
  //   ].searchForm.keywords = this.$store.state.user.pageUrl;
  //   this.$store.state.user.pageUrl = "";
  //   this.$refs["table"].getList();
  // },
  async mounted() {
    const service = (await getAllService()).data.payload;
    const client = (await getAllClient()).data.payload.rows;
    const ownership = (await getCompanies()).data.payload;
    this.header.searchs.forEach((item) => {
      if (item.key === "salesman_id") item.options = service[5];
      if (item.key === "client_id") item.options = client;
      if (item.key === "ownership") item.options = ownership;
    });
  },
};
</script>
